import React from 'react';
import './PageNavigation.css';

function PageNavigation({ currentPage, totalPages, onPageChange }) {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="page-navigation">
      <h3 className="page-nav-title">Pages</h3>
      <div className="page-list">
        {pages.map((page) => (
          <div
            key={page}
            className={`page-item ${currentPage === page ? 'active' : ''}`}
            onClick={() => onPageChange(page)}
          >
            <span className="page-number">{page}</span>
            {currentPage === page && <span className="page-indicator-dot"></span>}
          </div>
        ))}
      </div>
    </div>
  );
}

export default PageNavigation;

